import React from 'react'
import { ToastContainer } from 'react-toastify'

import 'react-toastify/dist/ReactToastify.css'

export default function Toast() {
  return (
    <ToastContainer
      position="top-center"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      // Above driver.js (.driver-popover z-index: 1e9) so tutorial-year error
      // toasts aren't hidden behind the RoboTutor overlay.
      style={{ zIndex: 2000000000 }}
    />
  )
}
